"use strict";const s=require("./set-message-Bczxd83K.js"),r=e=>{s.setMessage({message:e,type:"error"})};exports.setErrorMessage=r;
//# sourceMappingURL=set-error-message-wOvqmfA-.js.map
